import { render, staticRenderFns } from "./RegistrationPages.vue?vue&type=template&id=27405695&"
import script from "./RegistrationPages.vue?vue&type=script&lang=js&"
export * from "./RegistrationPages.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationPages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports